// Yol bazlı SEO landing page verileri
// TEM, D-100, O-4 gibi ana yollar için özel sayfalar

export const ROAD_PAGES = [
  {
    slug: 'tem-otoyolu-lastik-yol-yardim',
    name: 'TEM Otoyolu',
    title: 'TEM Otoyolu Lastik Yol Yardım Kocaeli | 7/24 Acil Oto Lastikçi',
    metaDesc: 'TEM Otoyolu Kocaeli lastik yol yardım. Gebze-İzmit-Gölcük arası TEM üzerinde 7/24 acil lastik tamiri, değişimi ve stepne hizmeti. Ortalama 20 dk müdahale.',
    h1: 'TEM Otoyolu Lastik Yol Yardım',
    h1Accent: 'Kocaeli Geçişi — 7/24 Acil Müdahale',
    intro: 'TEM Otoyolu Kocaeli geçişinde lastiğiniz mi patladı? 7/24 Lastik mobil ekibi TEM otoyolu üzerinde Gebze\'den Gölcük\'e kadar tüm güzergahta acil lastik yol yardım hizmeti sunar. Banket veya otoyol çıkışında — nerede olursanız olun, ekibimiz ortalama 20 dakikada yanınızda.',
    content: `<h2>TEM Otoyolu'nda Lastik Arızası — Ne Yapmalısınız?</h2>
<p>TEM Otoyolu, Türkiye'nin en yoğun trafikli güzergahlarından biridir. <strong>Kocaeli geçişi</strong> — özellikle Gebze-İzmit arasındaki bölüm — her gün yüz binlerce aracın geçtiği kritik bir koridor. Bu yoğunluk nedeniyle lastik arızaları sık yaşanır.</p>

<h3>TEM'de Lastik Patlaması Durumunda Adımlar</h3>
<ol>
<li><strong>Dörtlü flaşörleri yakın</strong> ve aracı güvenli bir şekilde bankete çekin</li>
<li><strong>Reflektör üçgeni koyun</strong> (en az 150 metre geride)</li>
<li><strong>0534 968 7611</strong> numarasını arayın — 7/24 aktifiz</li>
<li>WhatsApp ile <strong>konum gönderin</strong> — ekibimiz en kısa yoldan gelir</li>
</ol>

<h3>TEM Otoyolu Hizmet Noktalarımız</h3>
<p>Kocaeli TEM geçişinde şu noktalara hızlı müdahale sağlıyoruz:</p>
<ul>
<li><strong>Gebze TEM girişi</strong> — Dilovası kavşağı bölgesi</li>
<li><strong>Çayırova — Şekerpınar</strong> TEM bağlantı yolları</li>
<li><strong>Darıca — Gebze</strong> arası TEM güzergahı</li>
<li><strong>Derince — İzmit</strong> TEM bölümü</li>
<li><strong>Körfez — Hereke</strong> TEM geçişi</li>
<li><strong>Gölcük</strong> TEM çıkışı ve çevresi</li>
</ul>

<h3>Neden Bizi Tercih Etmelisiniz?</h3>
<p>TEM Otoyolu'nda lastik arızasına müdahale eden çok az firma vardır. 7/24 Lastik olarak <strong>otoyol üzerinde deneyimli</strong> ekibimizle güvenli ve hızlı müdahale sağlıyoruz. Aracınızı bankette bırakmanıza gerek yok — biz geliyoruz.</p>`,
    faqs: [
      { q: 'TEM otoyolunda lastik patlarsa ne yapmalıyım?', a: 'Flaşörlerinizi yakın, bankete çekin, reflektör koyun ve 0534 968 7611\'i arayın. 20 dakikada yanınızdayız.' },
      { q: 'TEM otoyoluna lastikçi kaç dakikada gelir?', a: 'TEM Kocaeli geçişine ortalama 15-25 dakikada ulaşıyoruz. Konumunuza göre değişir.' },
      { q: 'TEM\'de gece lastik tamiri yapılıyor mu?', a: 'Evet, 7/24 hizmet veriyoruz. Gece 03:00\'te bile TEM\'de lastik tamiri yapıyoruz.' },
      { q: 'TEM\'de ticari araç lastik tamiri var mı?', a: 'Evet, kamyon ve otobüs dahil tüm araç tiplerine TEM üzerinde hizmet veriyoruz.' },
    ],
  },
  {
    slug: 'd100-kocaeli-lastik-yol-yardim',
    name: 'D-100 Karayolu',
    title: 'D-100 Karayolu Lastik Yol Yardım Kocaeli | 7/24 Acil Lastikçi',
    metaDesc: 'D-100 Karayolu Kocaeli lastik yol yardım. Gebze-İzmit D-100 üzerinde 7/24 acil lastik tamiri ve değişimi. Eski İstanbul yolu lastikçi hizmeti.',
    h1: 'D-100 Karayolu Lastik Yol Yardım',
    h1Accent: 'Eski İstanbul Yolu — 7/24 Mobil Lastikçi',
    intro: 'D-100 Karayolu (eski İstanbul yolu) Kocaeli geçişinde 7/24 lastik yol yardım hizmeti. Gebze\'den İzmit\'e kadar D-100 üzerindeki tüm noktalara acil lastik tamiri, değişimi ve stepne hizmeti sunuyoruz.',
    content: `<h2>D-100 Karayolu'nda Lastik Yol Yardım</h2>
<p><strong>D-100 Karayolu</strong> (E-5, eski İstanbul yolu), Kocaeli'nin şehir içi trafiğinin yoğun olduğu ana arterlerden biridir. Özellikle Gebze, Darıca, Dilovası ve İzmit geçişlerinde lastik arızaları sık yaşanır. TEM'e alternatif olarak kullanılan bu yolda, trafik yoğunluğu nedeniyle hızlı müdahale kritik öneme sahiptir.</p>

<h3>D-100 Hizmet Bölgelerimiz</h3>
<ul>
<li><strong>Gebze D-100</strong> — Gebze merkez, eski sanayi yolu</li>
<li><strong>Darıca D-100</strong> — Darıca geçişi, sahil yolu bağlantısı</li>
<li><strong>Dilovası D-100</strong> — Sanayi bölgesi kavşakları</li>
<li><strong>Derince D-100</strong> — Liman bölgesi geçişi</li>
<li><strong>İzmit D-100</strong> — Şehir merkezi geçişi</li>
</ul>

<h3>D-100'de Lastik Arızası Riski</h3>
<p>D-100 karayolu, özellikle sanayi bölgeleri yakınlarında çivi, vida ve metal parça kaynaklı lastik arızaları yaşanır. Ayrıca yol çukurları ve kasis kaynaklı jant eğrilmeleri de sıktır. 7/24 Lastik mobil ekibi tüm bu arızalara yerinde müdahale eder.</p>`,
    faqs: [
      { q: 'D-100\'de lastik patlaması durumunda ne yapmalıyım?', a: 'Aracınızı güvenli bir yere çekin ve 0534 968 7611\'i arayın. Ortalama 15-20 dakikada yanınızdayız.' },
      { q: 'D-100 üzerinde gece lastikçi var mı?', a: 'Evet, D-100 Kocaeli geçişinde 7/24 mobil lastik hizmeti veriyoruz.' },
      { q: 'D-100 Gebze-İzmit arası lastikçi ücreti?', a: 'Hasar türüne göre değişir. Arayarak net fiyat bilgisi alabilirsiniz.' },
    ],
  },
  {
    slug: 'osmangazi-koprusu-lastik-yol-yardim',
    name: 'Osmangazi Köprüsü',
    title: 'Osmangazi Köprüsü Lastik Yol Yardım | 7/24 Acil Lastikçi O-4',
    metaDesc: 'Osmangazi Köprüsü ve O-4 otoyolu lastik yol yardım. Yalova-Bursa-İzmit güzergahı 7/24 acil lastik tamiri ve değişimi.',
    h1: 'Osmangazi Köprüsü Lastik Yol Yardım',
    h1Accent: 'O-4 Otoyolu — Yalova-Bursa Güzergahı',
    intro: 'Osmangazi Köprüsü (O-4 Otoyolu) ve Yalova-Bursa-Kocaeli güzergahında 7/24 lastik yol yardım hizmeti. Köprü çıkışı, Altınova, Karamürsel bağlantı yolları dahil tüm güzergahta acil lastik tamiri sunuyoruz.',
    content: `<h2>Osmangazi Köprüsü Güzergahında Lastik Yol Yardım</h2>
<p><strong>Osmangazi Köprüsü</strong> (O-4 Otoyolu), Kocaeli-Yalova-Bursa güzergahının en kritik bağlantı noktasıdır. Özellikle hafta sonları ve tatil dönemlerinde yoğun trafik yaşanan bu güzergahta lastik arızaları sık meydana gelir.</p>

<h3>O-4 Hizmet Noktalarımız</h3>
<ul>
<li><strong>Osmangazi Köprüsü çıkışı</strong> — Kocaeli tarafı</li>
<li><strong>Altınova — Karamürsel</strong> bağlantı yolu</li>
<li><strong>Yalova güzergahı</strong> — Kocaeli sınırları içinde</li>
<li><strong>Gölcük — Karamürsel</strong> sahil yolu bağlantısı</li>
</ul>

<p>Osmangazi Köprüsü çıkışında veya O-4 bağlantı yollarında lastik arızası yaşarsanız, <strong>0534 968 7611</strong> numarasından bize ulaşın. Ekibimiz en yakın noktadan hızla hareket eder.</p>`,
    faqs: [
      { q: 'Osmangazi Köprüsü\'nde lastik patlarsa ne yapmalıyım?', a: 'Köprü üzerinde durmak tehlikelidir. Mümkünse köprü çıkışına kadar devam edin ve güvenli bir yere çekin. 0534 968 7611\'i arayın.' },
      { q: 'O-4 otoyoluna lastikçi geliyor mu?', a: 'Evet, O-4 otoyolu Kocaeli geçişi ve Osmangazi Köprüsü çıkışına 7/24 hizmet veriyoruz.' },
    ],
  },
];

export const ALL_ROAD_SLUGS = ROAD_PAGES.map(r => r.slug);
export const getRoadBySlug = (slug) => ROAD_PAGES.find(r => r.slug === slug);
